import AbstractListResource from "./abstract/abstract-list-resource"
import defines from "dpsdk/defines"
const {Resource, ZoneType, ZoneScheduleDays, Direction} = defines
import Zone, {applyDeviceUpdatedAt} from './items/zone'

class Zones extends AbstractListResource {
    constructor() {
        super(Resource.ZONES, Zone)
        super.setCallbacks({
            get: (params) => this.api().resourceGet(Resource.ZONES, params),
            update: (id, params) => this.api().resourceUpdate(Resource.ZONES, id, params),
            create: (params) => this.api().resourceCreate(Resource.ZONES, params),
            delete: (id) => this.api().resourceDelete(Resource.ZONES, id)
        })
    }

    created(data, remoteUpdate = false) {
        applyDeviceUpdatedAt(data)
        return super.created(data, remoteUpdate)
    }

    clearForDevices(deviceIds) {
        return dispatch => {
            const ids = new Set(deviceIds.map(String))
            this.invalidatePendingLoad()
            const belongsToDevice = zone => zone && ids.has(String(zone.device_id))
            Object.keys(this.singleItems).forEach(key => {
                if (belongsToDevice(this.singleItems[key])) this.clearSingleData(key)
            })
            Object.keys(this.ids).forEach(key => {
                if (belongsToDevice(this.ids[key])) delete this.ids[key]
            })
            if (this.items) {
                const remaining = this.items.filter(zone => !belongsToDevice(zone))
                this.count = Math.max(0, this.count - (this.items.length - remaining.length))
                this.items = remaining
            }
            dispatch({type: `${this.resourceType}_RECEIVED`})
        }
    }

    updated(data, remoteUpdate = false) {
        applyDeviceUpdatedAt(data)
        return super.updated(data, remoteUpdate)
    }

    delete(id) {
        return (dispatch) => {
            dispatch({type: `${this.resourceType}_DELETING`, id})
            const item = this.findById(id)
            const deviceId = item ? item.device_id : null
            this.apiCallbacks.delete(id).then((data) => {
                applyDeviceUpdatedAt(data, deviceId)
                dispatch(this.deleted(id))
            }).catch((err) => {
                console.log(err)
                this.handleErrorCodes(err)
                dispatch({type: `${this.resourceType}_DELETE_FAILED`, id, error: err})
            })
        }
    }

    restoreItemsAfterLoad(previousItems, params) {
        const deviceId = params && params.device_id
        if (deviceId === undefined || deviceId === null || !previousItems || !previousItems.length) {
            return
        }

        previousItems.forEach(item => {
            if (String(item.device_id) !== String(deviceId) || !item.isChanged) {
                return
            }

            const current = this.ids[item.id]
            if (current && current.applyCoordinates) {
                current.applyCoordinates(item.getCoordinates())
                current.isChanged = true
            }
        })
    }

    weekDaysDorDropDown(t) {
        const result = []
        result.push(
            {
                label: t('zones.everyDay'),
                value: ZoneScheduleDays.EVERY_DAY
            },
            {
                label: t('zones.monday'),
                value: ZoneScheduleDays.MONDAY
            },
            {
                label: t('zones.tuesday'),
                value: ZoneScheduleDays.TUESDAY
            },
            {
                label: t('zones.wednesday'),
                value: ZoneScheduleDays.WEDNESDAY
            },
            {
                label: t('zones.thursday'),
                value: ZoneScheduleDays.THURSDAY
            },
            {
                label: t('zones.friday'),
                value: ZoneScheduleDays.FRIDAY
            },
            {
                label: t('zones.saturday'),
                value: ZoneScheduleDays.SATURDAY
            },
            {
                label: t('zones.sunday'),
                value: ZoneScheduleDays.SUNDAY
            },
            {
                label: t('zones.workingDays'),
                value: ZoneScheduleDays.WORKING_DAYS
            },
            {
                label: t('zones.dayOffs'),
                value: ZoneScheduleDays.DAY_OFFS
            }
        )
        return result
    }

    hoursForDropDown() {
        const result = []
        for (let i = 0; i < 24; i++) {
            result.push({
                label: i < 10 ? `0${i}` : i,
                value: i
            })
        }
        return result
    }

    minsForDropDown() {
        const result = []
        for (let i = 0; i < 60; i++) {
            result.push({
                label: i < 10 ? `0${i}` : i,
                value: i
            })
        }
        return result
    }

    directionsForDropDown(t) {
        const result = []
        result.push({
            label: t('zones.oncomingDirection'),
            value: Direction.ONCOMING
        })

        result.push({
            label: t('zones.passingDirection'),
            value: Direction.PASSING
        })

        return result
    }

    typesForDropDown(t) {
        const result = []
        Object.values(ZoneType).forEach(type => {
            if (parseInt(type) > 0 && type !== ZoneType.NONE) {
                result.push({
                    label: t(`zones.type.${type}`),
                    value: type
                })
            }
        })
        return result
    }
}

export default new Zones()
